import { Component, Inject } from '@angular/core';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { IReorderingDialogData } from './interfaces';

@Component({
    selector: 'azavista3-reordering-dialog',
    templateUrl: './reordering-dialog.component.html',
    standalone: false
})
export class ReorderingDialogComponent {
    constructor(
        public dialogRef: MatDialogRef<ReorderingDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: IReorderingDialogData) {
    }

    onCancelClick(): void {
        this.dialogRef.close();
    }

    onApplyClick(): void {
        this.dialogRef.close(this.data.items);
    }

    drop(event: CdkDragDrop<any[]>) {
        moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
    }
}
